import {
  MemberProfileCard,
  MemberProfileCardData,
  MemberProfileLocation
} from '@bo-components/members/memberProfile';
import {
  selectHasViewMemberDashIPInfo,
  selectHasViewMemberDashMap
} from '@bo-selectors/members/memberProfilePermissions';
import { MemberFetchStatus } from '@bo-components/members';
import { useMemberDetails } from '@bo-hooks/members/useMemberDetails';
import { useSelector } from 'react-redux';

export const MemberProfile = () => {
  const { isError, isLoading, memberProfile } = useMemberDetails();
  const hasViewMapPermission = useSelector(selectHasViewMemberDashMap);
  const hasViewIPInfoPermission = useSelector(selectHasViewMemberDashIPInfo);

  const isMemberNotFound = !memberProfile;

  if (isError || isLoading || isMemberNotFound) {
    return (
      <MemberFetchStatus
        isError={isError}
        isLoading={isLoading}
        isMemberNotFound={isMemberNotFound}
      />
    );
  }

  const { accountDetails, generalInfo, userInfo, ipInfo } = memberProfile;

  const memberId = generalInfo.userId.value;

  return (
    <section className="flex flex-col gap-4 px-6">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 2xl:grid-cols-3">
        <MemberProfileCard cardTitle="General Information">
          <MemberProfileCardData cardData={generalInfo} />
        </MemberProfileCard>
        <MemberProfileCard cardTitle="User Information">
          <MemberProfileCardData cardData={userInfo} />
        </MemberProfileCard>
        <MemberProfileCard cardTitle="Account Details">
          <MemberProfileCardData cardData={accountDetails} />
        </MemberProfileCard>
        {hasViewIPInfoPermission && (
          <MemberProfileCard cardTitle="IP Information">
            <MemberProfileCardData cardData={ipInfo} />
          </MemberProfileCard>
        )}
      </div>
      {hasViewMapPermission && (
        <MemberProfileCard key="map" cardTitle="Location Information">
          <MemberProfileLocation memberId={memberId} />
        </MemberProfileCard>
      )}
    </section>
  );
};
